import { IStaticPageItem } from '@ui';
import { cloneDeep } from 'lodash';

export const dataMobile: IStaticPageItem[] = [
  {
    title: 'Jumble - Setup',
    description: '',
    background: '',
    blocks: [
      {
        title: '',
        background: '',
        description: [
          {
            type: 'list',
            order: true,
            start: 1,
            value: [
              `
              Firstly, you’ll want to create a set of words / sentences or paragraphs for your learners to put in the correct order. To do this, click ‘create game’.  Then select ‘Jumble’ from the games menu. This will take you to the create game page where you can setup the game.
              `,
              `
              Choose the number of teams and students per team. This game can be played individually, but works best if played in teams.
              `,
              `
              Choose the game mode from the 3 options. If you choose ‘word’, students have to put words in the correct order order. Choose ‘sentence’ if you want students to put sentences in the correct order to make a paragraph.
              Choose ‘paragraph’ if you want students to put paragraphs in the correct order to make an essay.
              `,
              `
              You can add as many words / sentences / paragraphs as you want by clicking ‘add more’.
              `,
              `
              Please note that the parts will be jumbled up and randomly sent to students phone in the wrong order. They’ll have to work together to put them in the correct order.
              `,
              `
              You then have some options for timing. You can choose to have no time limit with normal mode. The other option is a time limit, where you can set a time limit of between 1 - 5 mins for each turn.
              `
            ]
          }
        ],
        image: '',
        subTitle: ''
      },
      {
        title: '',
        subTitle: '',
        description: [],
        background: '',
        image: 'learn_more_taboo.png'
      },
      {
        title: '',
        background: '',
        description: [
          {
            type: 'list',
            order: true,
            start: 7,
            value: [
              `
              Once you’ve added the game click ‘launch game’ This will give you the option to name the game and save it, before launching.
              `,
              `
              Once a student joins the game, they will randomly be assigned to a team. They do have an ability to switch teams. The teacher can also switch teams of any individual student. Note: if all teams are full, students joining will go to an ‘observations’ team, which is for students unassigned to a team.
              `,
              `
              Once all students have joined a team, click on ‘Start game!’
              `
            ]
          }
        ],
        image: '',
        subTitle: ''
      },
      {
        title: '',
        subTitle: '',
        description: [],
        background: '',
        image: 'learn_more_taboo_2.png'
      }
    ],
    subTitle: '',
    titleStyle: ''
  },
  {
    title: 'Jumble - During Play',
    description: '',
    background: '',
    blocks: [
      {
        title: '',
        background: '',
        description: [
          {
            type: 'list',
            order: true,
            start: 1,
            value: [
              `
              Once you’ve started the game, students will be alerted on their phones (or other personal device) and they will be asked to press ‘ready’.
              `,
              `
              Once they’ve all clicked on ‘ready’ a the words / sentences or paragraphs will be sent to student’s phone randomly and distributed equally.
              `,
              `
              For example, if there are 2 students per team and there are 4 parts to rearrange, each student will receive 2 parts. The goal is to work out the correct order by looking at each other’s devices to figure it out.
              `,
              `
              Once students are happy with their selection, they can click ‘submit’. Please note that all students must click submit before the team’s answers are submitted to the teacher.
              `,
              `
              Points are awarded automatically. For example, if students put 2 out of 4 words in the correct order they will get 2 points.
              `,
              `
              Answers can be reviewed on the teacher’s screen once all students have submitted their answer. Correct answers will be shown in green, incorrect in red.
              `,
              `
              Once the game has ended, there will be a game review screen which shows all the words played in that game.
              `,
              `
              The next screen is the score discussion. Scores will be calculated automatically during the game as points are gained / lost. However, if there are any disputes (e.g. a student has wrongfully been deducted points by mistake), the teacher has a chance here to adjust the scores. 
              `,
              `
              Once all scores are finalised, there will be a review of all the words followed by leaderboard displaying the scores of all teams who participated. 
              `,
              `
              The results screen will also display the time that the students took to submit their answers.
              `
            ]
          },
          {
            type: 'string',
            value: [
              'Note that if any students accidentally drop out at any point during the game, they are able to rejoin it by going to the same link, entering the same game code and entering the same name they used to enter previously. They’ll then need to click on ‘reconnect’. This will put them in the same group as they were in previously.'
            ]
          }
        ],
        image: '',
        subTitle: ''
      }
    ],
    subTitle: '',
    titleStyle: ''
  }
];

const genDataDesktop = () => {
  const [setup, play] = cloneDeep(dataMobile);

  const setupBlocks = setup.blocks;

  setupBlocks[0].description[0].value =
    setupBlocks[0].description[0].value.concat(
      setupBlocks[2].description[0].value
    );

  setupBlocks[0].image = 'learn_more_jumble.jpg';
  setupBlocks[0].row = true;

  setup.blocks = setup.blocks.slice(0, 1);

  return [
    setup,
    play,
    {
      title: 'Example round',
      description: '',
      background: '#83C0EC',
      blocks: [
        {
          title: '',
          background: '',
          description: [],
          image: 'jumble_guide.jpg',
          subTitle: '',
          imageFullWidth: true
        }
      ],
      subTitle: '',
      titleStyle: ''
    }
  ];
};

export const dataDesktop: IStaticPageItem[] = genDataDesktop();
